module.exports = __webpack_public_path__ + "img/pro_beijia_01.b924aa0c.png";